import { render, staticRenderFns } from "./UserAccessTable.vue?vue&type=template&id=3d1db026&scoped=true"
import script from "./UserAccessTable.vue?vue&type=script&lang=js"
export * from "./UserAccessTable.vue?vue&type=script&lang=js"
import style0 from "./UserAccessTable.vue?vue&type=style&index=0&id=3d1db026&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1db026",
  null
  
)

export default component.exports